const content = {
  level: "A1",
  unit: 2,
  title: "Daily Actions",
  description:
    "Common actions you do every day, at home and outside. Learn how to use verbs in simple sentences.",

  explanation: [
    "This unit focuses on daily actions that people usually do every day.",
    "These words are verbs, which means they show actions.",
    "In English, a sentence usually starts with the subject, then the verb.",
    "For example: I wake up. I eat breakfast. I go to work.",
    "We often talk about daily routines using the present simple tense.",
    "You can add time expressions like 'every day', 'in the morning', or 'at night' to make the sentence clearer.",
    "Some actions use two words, such as 'wake up' and 'go to work'. These are common in everyday English.",
    "Try to think about your own day and describe your routine step by step using these verbs."
  ],

  items: [
    {
      word: "wake up",
      phonetic: "/weɪk ʌp/",
      meaning: "يستيقظ",
      example: "I wake up at seven every day.",
      audio: "/sounds/vocabulary/A1/unit2/wake_up.mp3"
    },
    {
      word: "eat",
      phonetic: "/iːt/",
      meaning: "يأكل",
      example: "I eat breakfast in the morning.",
      audio: "/sounds/vocabulary/A1/unit2/eat.mp3"
    },
    {
      word: "go to work",
      phonetic: "/ɡoʊ tuː wɜːrk/",
      meaning: "يذهب إلى العمل",
      example: "I go to work by bus.",
      audio: "/sounds/vocabulary/A1/unit2/go_to_work.mp3"
    },
    {
      word: "study",
      phonetic: "/ˈstʌdi/",
      meaning: "يدرس",
      example: "She studies English every day.",
      audio: "/sounds/vocabulary/A1/unit2/study.mp3"
    },
    {
      word: "come home",
      phonetic: "/kʌm hoʊm/",
      meaning: "يعود إلى المنزل",
      example: "I come home at six in the evening.",
      audio: "/sounds/vocabulary/A1/unit2/come_home.mp3"
    },
    {
      word: "sleep",
      phonetic: "/sliːp/",
      meaning: "ينام",
      example: "I sleep at eleven o’clock.",
      audio: "/sounds/vocabulary/A1/unit2/sleep.mp3"
    }
  ]
};

export default content;